<template>
	<section id="installation-run" class="s-installation s-installation-run">
		<div class="contact__line"></div>

		<div class="row section-header" data-aos="fade-up">
			<div class="col-full">
				<h3 class="subhead" v-html="$t('titles.installationRunTitle')"></h3>
				<h1 class="display-2 display-2--light" v-html="$t('titles.installationRunTough')"></h1>
			</div>
		</div>

		<div class="row contact-content block-1-2 block-tab-full" data-aos="fade-up">
			<div class="installation-container inverted">
				<!--<div class="installation-item" data-aos="fade-up">
					<div class="installation-step"><span><i class="fas fa-sliders-h"></i></span></div>
					<div class="installation-description">
						<h3 v-html="$t('titles.installationStep1')"></h3>
						<p v-html="$t('texts.installationRunStep1Paragraph1')"></p>
						<div class="alert-box alert-box--success" v-html="$t('texts.installationRunStep1Notice1')"></div>
						<p v-html="$t('texts.installationRunStep1Paragraph2')"></p>
						<div class="alert-box alert-box--success" v-html="$t('texts.installationRunStep1Notice2', {url: 'https://www.cpuid.com/softwares/cpu-z.html'})"></div>
						<p v-html="$t('texts.installationRunStep1Paragraph3')"></p>
						<div class="alert-box alert-box--success">
							<table>
								<thead>
									<tr>
										<th v-html="$t('tables.installationRunThreads')"></th>
										<th v-html="$t('tables.installationRunExThreads')"></th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>1</td>
										<td>0</td>
									</tr>
									<tr>
										<td>2</td>
										<td>1</td>
									</tr>
									<tr>
										<td>4</td>
										<td>3</td>
									</tr>
									<tr>
										<td>6</td>
										<td>5</td>
									</tr>
									<tr>
										<td>&ge; 8</td>
										<td>7</td>
									</tr>
								</tbody>
							</table>
						</div>
						<p v-html="$t('texts.installationRunStep1Paragraph4')"></p>
						<p v-html="$t('texts.installationRunStep1Paragraph5')"></p>
						<div class="alert-box alert-box--success" v-html="$t('texts.installationRunStep1Notice3')"></div>
						<p v-html="$t('texts.installationRunStep1Paragraph6')"></p>

						<div class="installation-content">
							<button class="btn btn--primary" v-bind="{'data-show': buttonShow, 'data-hide': buttonHide}"></button>
							<div>
								<img v-bind="{src: '/static/images/instructions/run/01-' + languageCurrent + '.png'}" alt="" />
							</div>
						</div>
					</div>
				</div>-->

				<div class="installation-item">
					<div class="installation-step"><span><i class="fas fa-plus"></i></span></div>
					<div class="installation-description">
						<h3 v-html="$t('titles.installationStep1')"></h3>
						<!--<p v-html="$t('texts.installationRunStep2Paragraph1')"></p>
						<p v-html="$t('texts.installationRunStep2Paragraph2')"></p>-->
						<p v-html="$t('texts.installationRunStep2Paragraph3')"></p>
						<p v-html="$t('texts.installationRunStep2Paragraph4')"></p>

						<div class="installation-content">
							<button class="btn btn--primary" v-bind="{'data-show': buttonShow, 'data-hide': buttonHide}"></button>
							<div>
								<!--<img v-bind="{src: '/static/images/instructions/run/02-' + languageCurrent + '.png'}" alt="" />-->
								<img v-bind="{src: '/static/images/instructions/run/04-' + languageCurrent + '.png'}" alt="" />
							</div>
						</div>
					</div>
				</div>

				<div class="installation-item">
					<div class="installation-step"><span><i class="fas fa-check"></i></span></div>
					<div class="installation-description">
						<h3 v-html="$t('titles.installationStep2')"></h3>
						<!--<p v-html="$t('texts.installationRunStep3Paragraph1')"></p>
						<div class="alert-box alert-box--success">
							<ul>
								<li>@CUP_Terrains_Core</li>
								<li>@CUP_Terrains_Maps</li>
								<li>@RHSAFRF</li>
								<li>@RHSGREF</li>
								<li>@RHSSAF</li>
								<li>@RHSUSAF</li>
								<li>@task_force_radio</li>
								<li>@WOG3_Islands</li>
								<li>@WOG_ACE</li>
								<li>@WOG_Extra</li>
								<li>@WOG_Islands</li>
								<li>@WOG_Mods</li>
							</ul>
						</div>-->

						<p v-html="$t('texts.installationRunStep3Paragraph2')"></p>
						<p v-html="$t('texts.installationRunStep3Paragraph3')"></p>

						<div class="installation-content">
							<button class="btn btn--primary" v-bind="{'data-show': buttonShow, 'data-hide': buttonHide}"></button>
							<div>
								<!--<img v-bind="{src: '/static/images/instructions/run/03-' + languageCurrent + '.png'}" alt="" />-->
								<img v-bind="{src: '/static/images/instructions/run/05-' + languageCurrent + '.png'}" alt="" />
							</div>
						</div>
					</div>
				</div>

				<div class="installation-item">
					<div class="installation-step"><span><i class="fas fa-play"></i></span></div>
					<div class="installation-description">
						<h3 v-html="$t('titles.installationStep3')"></h3>
						<p v-html="$t('texts.installationRunStep4Paragraph2')"></p>
						<p v-html="$t('texts.installationRunStep4Paragraph1')"></p>

						<div class="installation-content">
							<button class="btn btn--primary" v-bind="{'data-show': buttonShow, 'data-hide': buttonHide}"></button>
							<div>
								<img v-bind="{src: '/static/images/instructions/run/06-' + languageCurrent + '.png'}" alt="" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	// work with collapsable instruction's content
	$(document).ready(function () {
		// get elements
		const $installation = $('.s-installation-run');
		const $buttons = $installation.find('.installation-content button');

		// set buttons text
		$buttons.each(function () {
			$(this).text($(this).attr('data-show'));
		});

		// work with collapsable content
		$installation.on('click', '.installation-content button', function () {
			// button element
			const $button = $(this);

			// get content holder
			const $holder = $(this).parent('.installation-content').find('> div');

			// detect what to do
			if ($holder.is(':visible')) {
				// slide it up
				$holder.slideUp(300, function () {
					// change button's text
					$button.text($button.attr('data-show'));
				});
			} else {
				// slide it down
				$holder.slideDown(300, function () {
					// change button's text
					$button.text($button.attr('data-hide'));
				});
			}
		});
	});

	// export
	export default {
		name: 'SectionInstallationRun',
		computed: {
			/**
			 * Get current language code.
			 * @return {String} language code
			 */
			languageCurrent: function() {
				return this.$store.state.languageCurrent;
			},

			/**
			 * Get translation for 'show' button.
			 * @return {String} translation
			 */
			buttonShow: function() {
				return this.$t('buttons.show')
			},

			/**
			 * Get translation for 'hide' button.
			 * @return {String} translation
			 */
			buttonHide: function() {
				return this.$t('buttons.hide')
			}
		},
		methods: {
			/**
			 * Update buttons translation after language change.
			 */
			updateButtonsTranslations: function() {
				const _this = this;
				$('.s-installation-run').find('.installation-content button').each(function () {
					// detect if container is visible
					if ($(this).next('div').is(':visible')) {
						// update button's text
						$(this).text(_this.$t('buttons.hide'));
					} else {
						// update button's text
						$(this).text(_this.$t('buttons.show'));
					}
				});
			}
		},
		watch: {
			/**
			 * Watch for changing of 'show' button translation
			 */
			buttonShow: function() {
				this.updateButtonsTranslations();
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/sections/InstallationRun.vue